export default __webpack_public_path__ + "static/media/Moondick.857652a2.PNG";